import { getFilterOptions, getSessions, getTransactions } from '../../../api';
import { onRequest } from '../..';
import { ActionsType, PropertyType } from '../../../common';
import { getFiltersUrl } from '../../../view/pages/PlayerSessions/PlayerSessions.helper';

const partnersInit = (user: PropertyType) => {
	const { partners } = user;
	return { partners };
};

const filtersInit = async (payload: PropertyType) => {
	const { token, filters } = payload;
	const resp = await getFilterOptions({ token, filters });
	return { ...resp.data };
};

const filterData = async (token: string, page: string, filters: PropertyType[], perPage: string) => {
	const query = filters.length ? getFiltersUrl(filters) : '';

	// Add guard to prevent api call if no required filters, and update filter values
	if (
		!query.includes('session_ids') &&
		!query.includes('aams_session_ids') &&
		!query.includes('partner_session_ids') &&
		!query.includes('start_date')
	) {
		return {
			filters,
			filtering: filters.length > 1,
			isFilterValid: false,
			sessions: [],
			currentPage: 1,
			sessionsLoading: false,
		};
	}

	const { sessions, pagesTotal } = await getSessions({
		token,
		page,
		query,
		perPage,
	});

	return {
		isFilterValid: true,
		pagesTotal,
		sessions,
		filters,
		filtering: filters.length > 1,
		currentPage: page,
		sessionsLoading: false,
	};
};

const onFilter = async (state: PropertyType, payload: PropertyType) => {
	const { token, page, filters } = payload;

	return filterData(token, page, filters, state.perPage);
};

const onGetTransactions = async (payload: PropertyType) => {
	const { token, page, sessionID, perPage } = payload;
	const query = `?session_ids=${sessionID}`;

	const { transactions, pagesTotal } = await getTransactions({
		token,
		page,
		query,
		perPage,
	});
	return {
		transactions,
		pagesTotalTransactions: pagesTotal,
		currentPageTransactions: page,
	};
};

const onPageUpdate = async (state: PropertyType, payload: PropertyType) => {
	const { token, page, perPage } = payload;
	return filterData(token, page, state.filters, perPage);
};

const onUpdateColumns = async (payload: PropertyType) => {
	const rawValue = JSON.stringify(payload);
	localStorage.setItem('sessionsList', rawValue);
	return { columns: payload };
};

export const actions: ActionsType = {
	LOADING: (state, payload) => ({ sessionsLoading: payload }),
	FILTERS_INIT: (state, payload) => onRequest(() => filtersInit(payload)),
	PARTNERS_INIT: (state, payload) => partnersInit(payload),
	PER_PAGE: (state, payload) => ({ perPage: payload }),
	PAGE_UPDATE: (state, payload) => onRequest(() => onPageUpdate(state, payload), true),
	INIT_COLUMNS: (state, payload) => ({
		columns: payload.columns,
		initialColumns: payload.initialColumns,
	}),
	UPDATE_COLUMNS: (state, payload) => onUpdateColumns(payload),
	UPDATE_ROWS: (state, payload) => ({ rows: payload }),
	UPDATE_TRANSACTIONS_ROWS: (state, payload) => ({ transactionsRows: payload }),
	FILTER: (state, payload) => onFilter(state, payload),
	UPDATE_FILTERS: (state, payload) => ({ filters: payload }),
	TRANSACTIONS_INIT: (state, payload) => onGetTransactions(payload),
	GLOBAL_ERROR: (state, payload) => ({ globalErrors: payload }),
	GLOBAL_SUCCESS: (state, payload) => ({ globalSuccess: payload }),
	MESSAGE_INVALIDATE: () => ({ globalErrors: [], globalSuccess: '', sessionsLoading: false }),
};
